import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useOutletContext } from "react-router";
import { Consts } from "../Consts";
import noProfilePhotoIcon from "../assets/no-profile-photo.png";
import SynchronizationButton from "../components/SynchronizationButton";
import { localizeState } from "../utils/registrationRenderHelpers";

export function NewRegistrations() {
  const { event } = useOutletContext();

  const [res, setRes] = useState([]);
  useEffect(() => console.log("USER RESULT CHANGED:", res), [res])

  const [regs, setRegs] = useState(null);
  useEffect(() => console.log("REGISTRATIONS CHANGED:", regs), [regs])

  const [searchText, setSearchText] = useState("");

  async function parseJsonSafe(response) {
    try {
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  useEffect(() => {
    fetch(
      Consts.baseUrl +
        "api/event-registrations/findbyevent/" +
        localStorage.getItem("event"),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    ).then(async (res) => {
      if (!res.ok) {
        const responseBody = await parseJsonSafe(res);
        console.error("Initial registrations fetch failed", res.status, responseBody);
        setRegs([]);
        return;
      }
      const responseBody = await parseJsonSafe(res);
      setRegs(Array.isArray(responseBody) ? responseBody : []);
    });
  }, []);

  if (!event || !regs)
    return (
      <div
        className="spinner-border"
        role="status"
        style={{
          "--bs-spinner-width": "5rem",
          "--bs-spinner-height": "5rem",
          "--bs-spinner-border-width": "0.5em",
        }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    );

  const search = () => {
    fetch(Consts.baseUrl + "api/users/?s=" + searchText, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    }).then(async (res) => {
      if (!res.ok) {
        const responseBody = await parseJsonSafe(res);
        console.error("User search failed", res.status, responseBody);
        setRes([]);
        return;
      }
      setRes(
        (await res.json()).map(u => {return {
          id: u.id,
          picture: u.picture,
          name: `${u.lastName} ${u.firstName}`,
          companyName: u.company?.name,
          reservationConflictId: u.company?.reservationConflictId,
        }}).sort((a, b) => a?.name.localeCompare(b?.name))
      )
    });
  };

  async function insertOrUpdateRegistration(userId, newValue) {
    const response = await fetch(`${Consts.baseUrl}api/event-registrations/adminRegister/${localStorage.getItem("event")}/${userId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: newValue,
    });

    const responseBody = await parseJsonSafe(response);
    if (!response.ok || !responseBody?.registration) {
      console.error("insertOrUpdateRegistration failed", response.status, responseBody);
      alert(responseBody?.error?.message ?? "Nem sikerült menteni a státuszt.");
      return;
    }

    if (responseBody?.crmSyncSuccessful === false) {
      alert("Státusz mentve, de a CRM szinkron nem sikerült. A rendszer automatikusan újrapróbálja.");
    }

    setRegs(previousRegs => {
      if (!previousRegs) return previousRegs;
      const nextRegs = [...previousRegs];
      const regIndex = nextRegs.findIndex(r => r.user.id === userId);
      if (regIndex >= 0) {
        nextRegs[regIndex] = {
          ...nextRegs[regIndex],
          state: responseBody.registration.state,
          online: responseBody.registration.online,
        };
      } else {
        nextRegs.push(responseBody.registration);
      }
      return nextRegs;
    });
  }
  const syncWithCRM = () => {
    fetch(Consts.baseUrl + "api/crm/sync-users", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(async (res) => {
        if (!res.ok) {
          const responseBody = await parseJsonSafe(res);
          console.error("CRM sync users failed", res.status, responseBody);
          alert(responseBody?.error?.message ?? "A CRM szinkron nem sikerült.");
          return;
        }
        await parseJsonSafe(res);
      });
  }

  return (
    <div className="row wrapper">
      <div className="new-registration-upper-div">
        <h2>ÚJ RÉSZTVEVŐ HOZZÁADÁSA:</h2>
        <div className="new-registration-upper-div-upper-row">
          <div className="new-registration-upper-div-lower-row">
            <input
              className="inputSearch"
              type="search"
              onChange={(e) => setSearchText(e.target.value)}
            />
            <input
              className="searchbutton"
              type="button"
              value="Keresés"
              onClick={search}
            />
          </div>
          <SynchronizationButton onSync={syncWithCRM}/>
        </div>
      </div>

      {res && (
        <table className="new-registration table table-bordered">
          <thead>
            <tr key="header">
              <th scope="col">Státusz</th>
              <th scope="col">Fotó</th>
              <th scope="col">Név</th>
              <th scope="col">Cégnév</th>
              <th scope="col">Ütközés ID</th>
            </tr>
          </thead>
          <tbody>
            {res?.map((u, index) => {
              const state = regs.find(r => r.user.id === u.id)?.state ?? null
              const isOnline = regs.find(r => r.user.id === u.id)?.online ?? null
              return (
                <tr key={index}>
                  <td>
                    <Dropdown onSelect={(eventKey) => insertOrUpdateRegistration(u.id, eventKey)}>
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        {localizeState(state, event.addresses.some(a => !a.location || a.location === "") && isOnline, 'Hozzáadás')}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Registered", online: false})}>Biztos jön</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Canceled"})}>Lemondta</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Appeared", online: false})}>Megjelent</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Waiting"})}>Várólista</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Interested"})}>Érdeklődő</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Applied"})}>Jelentkezett</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Denied"})}>Elutasított</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "WontAttend"})}>Biztos nem jön</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "NotAppeared", online: false})}>Nem jelent meg</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Registered", online: true})}>Biztos jön - online</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "Appeared", online: true})}>Megjelent - online</Dropdown.Item>
                        <Dropdown.Item eventKey={JSON.stringify({state: "NotAppeared", online: true})}>Nem jelent meg - online</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                  <td className="imgwrapper" scope="row">
                    <img
                      src={
                        (u.picture && u.picture?.url)
                          ? Consts.baseUrl + u.picture.url.slice(1)
                          : noProfilePhotoIcon
                      }
                      className="img-fluid rounded"
                      alt="..."
                    />
                  </td>
                  <td>
                    {u.name}
                  </td>
                  <td>{u.companyName ?? "Nincs cég megadva"}</td>
                  <td style={{ textAlign: "center" }} >{u.reservationConflictId}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
